import { GET_INFO_APPLY_START } from '../../types';

export const get_info_apply = (payload) => ({
  type: GET_INFO_APPLY_START,
  payload,
});
